type RoleClaimObject = {
  key?: unknown;
  name?: unknown;
  id?: unknown;
};

function roleClaimToString(value: unknown): string | null {
  if (typeof value === "string" && value.length > 0) {
    return value;
  }
  if (value && typeof value === "object") {
    const role = value as RoleClaimObject;
    if (typeof role.key === "string" && role.key.length > 0) {
      return role.key;
    }
    if (typeof role.name === "string" && role.name.length > 0) {
      return role.name;
    }
  }
  return null;
}

/** Kinde access token `roles`: string keys, or objects with `key` / `name`. */
export function parseJwtRoles(claim: unknown): string[] {
  if (!Array.isArray(claim)) {
    return [];
  }
  const roles: string[] = [];
  for (const entry of claim) {
    const role = roleClaimToString(entry);
    if (role) {
      roles.push(role);
    }
  }
  return roles;
}
